import { DatePipe } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CoilDetailComponent } from '../coil-detail/coil-detail.component';

@Component({
  selector: 'app-coil-detail-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    CoilDetailComponent
  ],
  providers: [DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './coil-detail-dialog.component.html',
  styleUrl: './coil-detail-dialog.component.scss'
})
export class CoilDetailDialogComponent {
  hideTitle: boolean = false;
  hideOrderOverview: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CoilDetailDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.hideTitle = true;
      this.hideOrderOverview = true;
  }
}
